import { jsxs as b, jsx as s, Fragment as sr } from "react/jsx-runtime";
import { forwardRef as cr } from "react";
function or(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var j = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var k;
function lr() {
  return k || (k = 1, function(t) {
    (function() {
      var u = {}.hasOwnProperty;
      function e() {
        for (var r = "", a = 0; a < arguments.length; a++) {
          var n = arguments[a];
          n && (r = i(r, p.call(this, n)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return e.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var a = "";
        for (var n in r)
          u.call(r, n) && r[n] && (a = i(a, this && this[n] || n));
        return a;
      }
      function i(r, a) {
        return a ? r ? r + " " + a : r + a : r;
      }
      t.exports ? (e.default = e, t.exports = e) : window.classNames = e;
    })();
  }(j)), j.exports;
}
var dr = lr();
const o = /* @__PURE__ */ or(dr), _r = {
  "purpur-card__container": "_purpur-card__container_fwz6v_1",
  "purpur-card__container--full-height": "_purpur-card__container--full-height_fwz6v_4",
  "purpur-card": "_purpur-card_fwz6v_1"
};
function gr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var q = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var R;
function hr() {
  return R || (R = 1, function(t) {
    (function() {
      var u = {}.hasOwnProperty;
      function e() {
        for (var r = "", a = 0; a < arguments.length; a++) {
          var n = arguments[a];
          n && (r = i(r, p.call(this, n)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return e.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var a = "";
        for (var n in r)
          u.call(r, n) && r[n] && (a = i(a, this && this[n] || n));
        return a;
      }
      function i(r, a) {
        return a ? r ? r + " " + a : r + a : r;
      }
      t.exports ? (e.default = e, t.exports = e) : window.classNames = e;
    })();
  }(q)), q.exports;
}
var fr = hr();
const vr = /* @__PURE__ */ gr(fr), mr = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, yr = vr.bind(mr), H = "purpur-icon", br = "md", $r = (t) => t.filter((u) => Object.keys(u).length >= 1).map((u) => `${u.name}="${u.value}"`).join(" "), wr = ({ content: t = "", title: u } = {}) => {
  const e = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    u ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], p = u ? `<title>${u}</title>` : "";
  return `<svg ${$r(e)}>${p}${t}</svg>`;
}, xr = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), X = ({
  ["data-testid"]: t,
  svg: u,
  allyTitle: e,
  className: p,
  size: i = br,
  ...r
}) => {
  const a = wr({
    content: xr(u.svg),
    title: e
  }), n = yr(p, H, `${H}--${i}`);
  return /* @__PURE__ */ s(
    "span",
    {
      className: n,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: a },
      ...r
    }
  );
};
X.displayName = "Icon";
const Nr = {
  name: "alert",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="m13.038 7.067-.247 6.876h-1.566l-.247-6.876a1.03 1.03 0 1 1 2.06 0Zm.212 8.917c0 .649-.586 1.234-1.25 1.234-.649 0-1.25-.585-1.25-1.234 0-.633.601-1.234 1.25-1.234.664 0 1.25.601 1.25 1.234Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["alert"],
  category: "status"
}, jr = {
  name: "check-circle",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M16.487 9.514a.872.872 0 1 0-1.42-1.014l-4.248 5.948-2.18-2.18a.872.872 0 0 0-1.233 1.234l2.908 2.908a.872.872 0 0 0 1.326-.11l4.847-6.786Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["check-circle"],
  category: "status"
}, zr = {
  name: "devices",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10 3.4a.1.1 0 0 0-.1.1V4a.9.9 0 0 1-1.8 0v-.5c0-1.05.85-1.9 1.9-1.9h10c1.05 0 1.9.85 1.9 1.9v15a1.9 1.9 0 0 1-1.9 1.9h-6a.9.9 0 1 1 0-1.8h6a.1.1 0 0 0 .1-.1v-15a.1.1 0 0 0-.1-.1H10ZM2.1 8c0-1.05.85-1.9 1.9-1.9h6c1.05 0 1.9.85 1.9 1.9v12a1.9 1.9 0 0 1-1.9 1.9H4A1.9 1.9 0 0 1 2.1 20V8ZM4 7.9a.1.1 0 0 0-.1.1v12a.1.1 0 0 0 .1.1h6a.1.1 0 0 0 .1-.1V8a.1.1 0 0 0-.1-.1H4ZM14.6 17a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8h-.5a.9.9 0 0 1-.9-.9Zm-8.5 1.5a.9.9 0 0 1 .9-.9h.5a.9.9 0 1 1 0 1.8H7a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>',
  keywords: ["devices"],
  category: "device"
}, Cr = {
  name: "error",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M10.354 3.05c.732-1.267 2.56-1.267 3.291 0l8.66 15c.732 1.267-.182 2.85-1.645 2.85H3.34c-1.463 0-2.377-1.583-1.646-2.85l8.66-15Zm1.595.862a.092.092 0 0 0-.036.038l-8.66 15a.092.092 0 0 0-.015.05c0 .014.005.032.015.05a.11.11 0 0 0 .036.038.09.09 0 0 0 .05.012H20.66a.088.088 0 0 0 .05-.012.106.106 0 0 0 .037-.038.105.105 0 0 0 .015-.05.092.092 0 0 0-.015-.05l-8.66-15a.092.092 0 0 0-.036-.038A.106.106 0 0 0 12 3.9a.105.105 0 0 0-.05.012Z" clip-rule="evenodd"/><path d="m12.523 14.922.412-6.25a.936.936 0 1 0-1.868 0l.421 6.25h1.035ZM12 17.52c.44 0 .826-.387.826-.815 0-.418-.387-.816-.826-.816-.428 0-.825.398-.825.816 0 .428.397.815.825.815Z"/><path fill-rule="evenodd" d="M12.691 15.096h-1.37l-.431-6.53a1 1 0 0 1 .997-1.066h.227a1 1 0 0 1 .998 1.064l-.42 6.532Zm.244-6.425a.936.936 0 1 0-1.868.002l.421 6.249h1.035l.412-6.25ZM13 16.706c0 .526-.466.99-1 .99-.522 0-1-.463-1-.99 0-.264.125-.51.304-.689.18-.178.429-.301.696-.301.536 0 1 .475 1 .99Zm-.174 0c0 .428-.387.815-.826.815-.428 0-.825-.387-.825-.815 0-.418.397-.816.825-.816.44 0 .826.398.826.816Z" clip-rule="evenodd"/></svg>',
  keywords: ["error"],
  category: "status"
}, Sr = {
  name: "info",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M11 8.18c0 .537.469.979 1.007.979.524 0 .993-.442.993-.98s-.469-.979-.993-.979c-.538 0-1.007.441-1.007.98Zm.152 1.958v6.897h1.696v-6.897h-1.696Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["info"],
  category: "status"
}, Ar = {
  name: "offering",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.118 4.6H7a1.9 1.9 0 0 0-1.9 1.9V8a1.9 1.9 0 0 0 1.5 1.858v.642a.9.9 0 1 0 1.8 0v-.6h3.2v.6a.9.9 0 0 0 1.8 0v-.6h3.7V11a.9.9 0 0 0 1.8 0V9.858A1.9 1.9 0 0 0 20.4 8V6.5a1.9 1.9 0 0 0-1.9-1.9h-.618c-.063-.708-.3-1.394-.756-1.943-.56-.674-1.384-1.057-2.376-1.057-.92 0-1.696.33-2.25.915-.554-.585-1.33-.915-2.25-.915-.992 0-1.816.383-2.376 1.057-.457.549-.693 1.235-.756 1.943Zm1.812 0h2.64c-.053-.34-.174-.607-.328-.792-.192-.232-.493-.408-.992-.408s-.8.176-.992.408c-.154.185-.275.452-.328.792Zm4.5 0h2.64c-.053-.34-.174-.607-.328-.792-.192-.232-.493-.408-.992-.408s-.8.176-.992.408c-.154.185-.275.452-.328.792Zm-.03 3.5h5.1a.1.1 0 0 0 .1-.1V6.5a.1.1 0 0 0-.1-.1h-5.1v1.7Zm-1.8-1.7H7a.1.1 0 0 0-.1.1V8a.1.1 0 0 0 .1.1h4.6V6.4Zm8.335 5.147c.743-.107 1.52.135 2.201.817.474.473.695 1.011.708 1.548.012.508-.163.927-.318 1.2-.185.326-.47.607-.634.77l-.049.047-4.414 4.414a1.9 1.9 0 0 1-1.343.557H7.914a.1.1 0 0 0-.07.03l-.5.5a1.9 1.9 0 0 1-2.687 0L2.57 19.342a1.9 1.9 0 0 1 0-2.686l4-4a1.9 1.9 0 0 1 1.343-.557H14.5v.9-.9h.041l.065.004a2.73 2.73 0 0 1 .79.185 2.665 2.665 0 0 1 1.46 1.417c.188-.162.375-.324.551-.479.46-.401.815-.722.957-.863.338-.34.882-.719 1.571-.817ZM15.088 15.1a1.06 1.06 0 0 0 .08-.145c.1-.207.113-.38.027-.553a.867.867 0 0 0-.668-.497.628.628 0 0 0-.042-.005h-6.57a.1.1 0 0 0-.071.03l-4 4a.1.1 0 0 0 0 .14l2.085 2.087a.1.1 0 0 0 .142 0l.5-.5a1.9 1.9 0 0 1 1.343-.557h8.172a.1.1 0 0 0 .07-.03l4.415-4.414c.225-.225.334-.335.39-.434a.539.539 0 0 0 .083-.266.283.283 0 0 0-.026-.11.712.712 0 0 0-.154-.21c-.319-.318-.542-.326-.674-.307-.186.026-.392.146-.554.307-.191.192-.595.553-1.043.946-.904.79-2.143 1.838-2.561 2.144l-.238.174H10.5a.9.9 0 0 1 0-1.8h4.588Z" clip-rule="evenodd"/></svg>',
  keywords: ["offering"],
  category: "other"
}, Or = {
  name: "question",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13.672 12.056c-.635.547-1.242 1.07-1.164 2.062h-1.385c-.309-1.553.504-2.214 1.23-2.805.514-.419.986-.802.986-1.442 0-.593-.489-1.068-1.267-1.068-.764 0-1.345.422-1.872 1.187L9 9.067C9.712 7.92 10.807 7.3 12.086 7.3 13.906 7.3 15 8.42 15 9.78c0 1.133-.678 1.717-1.328 2.277Zm-.822 3.763c0 .54-.487 1.028-1.041 1.028-.554 0-1.042-.488-1.042-1.028 0-.528.488-1.029 1.042-1.029s1.042.501 1.042 1.029Z"/><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-1.75 0a8.25 8.25 0 1 1-16.5 0 8.25 8.25 0 0 1 16.5 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["question"],
  category: "status"
}, Zr = {
  name: "tag",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3.1 4a.9.9 0 0 1 .9-.9h6.5a.9.9 0 0 1 .636.264l10 10a.9.9 0 0 1 0 1.272l-4.5 4.5a.9.9 0 1 1-1.272-1.272L19.227 14l-9.1-9.1H4.9v5.227l9.736 9.737a.9.9 0 1 1-1.272 1.272l-10-10A.9.9 0 0 1 3.1 10.5V4ZM8 7.4a.6.6 0 1 0 0 1.2.6.6 0 0 0 0-1.2ZM5.6 8a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0Z" clip-rule="evenodd"/></svg>',
  keywords: ["tag"],
  category: "other"
};
function Mr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var P = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var E;
function kr() {
  return E || (E = 1, function(t) {
    (function() {
      var u = {}.hasOwnProperty;
      function e() {
        for (var r = "", a = 0; a < arguments.length; a++) {
          var n = arguments[a];
          n && (r = i(r, p(n)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return e.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var a = "";
        for (var n in r)
          u.call(r, n) && r[n] && (a = i(a, n));
        return a;
      }
      function i(r, a) {
        return a ? r ? r + " " + a : r + a : r;
      }
      t.exports ? (e.default = e, t.exports = e) : window.classNames = e;
    })();
  }(P)), P.exports;
}
var qr = kr();
const L = /* @__PURE__ */ Mr(qr), z = {
  "purpur-badge": "_purpur-badge_1mlzj_1",
  "purpur-badge__icon": "_purpur-badge__icon_1mlzj_13",
  "purpur-badge--attention": "_purpur-badge--attention_1mlzj_17",
  "purpur-badge--special": "_purpur-badge--special_1mlzj_21",
  "purpur-badge--neutral": "_purpur-badge--neutral_1mlzj_25",
  "purpur-badge--general": "_purpur-badge--general_1mlzj_29",
  "purpur-badge--information": "_purpur-badge--information_1mlzj_33",
  "purpur-badge--success": "_purpur-badge--success_1mlzj_37",
  "purpur-badge--warning": "_purpur-badge--warning_1mlzj_41",
  "purpur-badge--error": "_purpur-badge--error_1mlzj_45",
  "purpur-badge--black-friday": "_purpur-badge--black-friday_1mlzj_49"
}, C = "purpur-badge", d = {
  ATTENTION: "attention",
  BLACK_FRIDAY: "black-friday",
  ERROR: "error",
  GENERAL: "general",
  INFORMATION: "information",
  NEUTRAL: "neutral",
  SPECIAL: "special",
  SUCCESS: "success",
  WARNING: "warning"
}, Rr = (t) => {
  switch (t) {
    case d.ATTENTION:
    case d.SPECIAL:
      return Ar;
    case d.INFORMATION:
      return Sr;
    case d.GENERAL:
      return zr;
    case d.SUCCESS:
      return jr;
    case d.WARNING:
      return Nr;
    case d.ERROR:
      return Cr;
    case d.NEUTRAL:
      return Or;
    case d.BLACK_FRIDAY:
      return Zr;
    default:
      return;
  }
}, Hr = ({
  children: t,
  showIcon: u = !0,
  iconAllyTitle: e,
  variant: p,
  ["data-testid"]: i,
  className: r = "",
  ...a
}) => {
  const n = Rr(p), c = L([r, z[C], z[`${C}--${p}`]]);
  return /* @__PURE__ */ b("span", { className: c, "data-testid": i, ...a, children: [
    u && n && /* @__PURE__ */ s(
      X,
      {
        "data-testid": `${i}-icon`,
        allyTitle: e,
        size: "xs",
        svg: n,
        className: L(z[`${C}__icon`])
      }
    ),
    t
  ] });
}, Pr = {
  "purpur-card-badge": "_purpur-card-badge_k9ziu_1"
}, Er = o.bind(Pr), Lr = "purpur-card-badge", Tr = ({
  ["data-testid"]: t = "purpur-card-badge",
  variant: u,
  text: e
}) => u && e ? /* @__PURE__ */ s(
  Hr,
  {
    className: Er(Lr),
    variant: u,
    showIcon: !1,
    "data-testid": t,
    children: e
  }
) : null, Br = {
  "purpur-card-content": "_purpur-card-content_2uc00_1"
}, Ir = o.bind(Br), Vr = "purpur-card-content", Fr = ({
  ["data-testid"]: t = "purpur-card-content",
  children: u
}) => /* @__PURE__ */ s("div", { className: Ir(Vr), "data-testid": t, children: u }), Gr = {
  "purpur-card-content-container": "_purpur-card-content-container_putaw_1",
  "purpur-card-content-container--footer": "_purpur-card-content-container--footer_putaw_12",
  "purpur-card-content-container--gap-size--sm": "_purpur-card-content-container--gap-size--sm_putaw_20",
  "purpur-card-content-container--gap-size--md": "_purpur-card-content-container--gap-size--md_putaw_23",
  "purpur-card-content-container--gap-size--lg": "_purpur-card-content-container--gap-size--lg_putaw_26"
}, Dr = o.bind(Gr), S = "purpur-card-content-container", Ur = ({
  ["data-testid"]: t = "purpur-card-content-container",
  children: u,
  className: e,
  isFooter: p = !1,
  gapSize: i = "md",
  ...r
}) => /* @__PURE__ */ s(
  "div",
  {
    className: Dr([
      S,
      e,
      `${S}--gap-size--${i}`,
      {
        [`${S}--footer`]: p
      }
    ]),
    "data-testid": t,
    ...r,
    children: u
  }
);
function Kr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var T = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var B;
function Wr() {
  return B || (B = 1, function(t) {
    (function() {
      var u = {}.hasOwnProperty;
      function e() {
        for (var r = "", a = 0; a < arguments.length; a++) {
          var n = arguments[a];
          n && (r = i(r, p(n)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return e.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var a = "";
        for (var n in r)
          u.call(r, n) && r[n] && (a = i(a, n));
        return a;
      }
      function i(r, a) {
        return a ? r ? r + " " + a : r + a : r;
      }
      t.exports ? (e.default = e, t.exports = e) : window.classNames = e;
    })();
  }(T)), T.exports;
}
var Yr = Wr();
const I = /* @__PURE__ */ Kr(Yr), Jr = "_rotate_1xozj_1", Qr = "_dash_1xozj_1", f = {
  "purpur-spinner": "_purpur-spinner_1xozj_1",
  rotate: Jr,
  "purpur-spinner--xxs": "_purpur-spinner--xxs_1xozj_4",
  "purpur-spinner--xs": "_purpur-spinner--xs_1xozj_8",
  "purpur-spinner--sm": "_purpur-spinner--sm_1xozj_12",
  "purpur-spinner--md": "_purpur-spinner--md_1xozj_16",
  "purpur-spinner--lg": "_purpur-spinner--lg_1xozj_20",
  "purpur-spinner__circle": "_purpur-spinner__circle_1xozj_24",
  dash: Qr,
  "purpur-spinner__circle--disabled": "_purpur-spinner__circle--disabled_1xozj_33",
  "purpur-spinner__circle--negative": "_purpur-spinner__circle--negative_1xozj_36"
}, v = "purpur-spinner", Xr = {
  SM: "sm"
}, rt = ({
  ["data-testid"]: t,
  disabled: u = !1,
  negative: e = !1,
  size: p = Xr.SM,
  ...i
}) => /* @__PURE__ */ s(
  "div",
  {
    className: I([f[v], f[`${v}--${p}`]]),
    "data-testid": t,
    ...i,
    children: /* @__PURE__ */ s("svg", { viewBox: "0 0 50 50", children: /* @__PURE__ */ s(
      "circle",
      {
        className: I(f[`${v}__circle`], {
          [f[`${v}__circle--disabled`]]: u,
          [f[`${v}__circle--negative`]]: e
        }),
        cx: "25",
        cy: "25",
        r: "20"
      }
    ) })
  }
), tt = {
  "purpur-card-cta--button-styling": "_purpur-card-cta--button-styling_1wc0z_1",
  "purpur-card-cta--button-styling--xs": "_purpur-card-cta--button-styling--xs_1wc0z_33",
  "purpur-card-cta--button-styling--icon-only": "_purpur-card-cta--button-styling--icon-only_1wc0z_36",
  "purpur-card-cta--button-styling--sm": "_purpur-card-cta--button-styling--sm_1wc0z_39",
  "purpur-card-cta--button-styling--md": "_purpur-card-cta--button-styling--md_1wc0z_45",
  "purpur-card-cta--button-styling--lg": "_purpur-card-cta--button-styling--lg_1wc0z_51",
  "purpur-card-cta--button-styling--full-width": "_purpur-card-cta--button-styling--full-width_1wc0z_57",
  "purpur-card-cta--button-styling--primary": "_purpur-card-cta--button-styling--primary_1wc0z_60",
  "purpur-card-cta--button-styling--disabled": "_purpur-card-cta--button-styling--disabled_1wc0z_64",
  "purpur-card-cta--button-styling--primary-negative": "_purpur-card-cta--button-styling--primary-negative_1wc0z_70",
  "purpur-card-cta--button-styling--secondary": "_purpur-card-cta--button-styling--secondary_1wc0z_82",
  "purpur-card-cta--button-styling--secondary-negative": "_purpur-card-cta--button-styling--secondary-negative_1wc0z_93",
  "purpur-card-cta--button-styling--expressive": "_purpur-card-cta--button-styling--expressive_1wc0z_104",
  "purpur-card-cta--button-styling--expressive-negative": "_purpur-card-cta--button-styling--expressive-negative_1wc0z_114",
  "purpur-card-cta--cta-styling": "_purpur-card-cta--cta-styling_1wc0z_126",
  "purpur-card-cta--secondary": "_purpur-card-cta--secondary_1wc0z_131",
  "purpur-card-cta--disabled": "_purpur-card-cta--disabled_1wc0z_131",
  "purpur-card-cta--text": "_purpur-card-cta--text_1wc0z_139"
}, at = o.bind(tt), _ = "purpur-card-cta", et = ({
  ["data-testid"]: t = "purpur-card-cta",
  className: u,
  children: e,
  disabled: p = !1,
  iconPosition: i = "right",
  loading: r = !1,
  text: a,
  linkStyling: n = !1,
  ...c
}) => /* @__PURE__ */ s(
  "div",
  {
    className: `${at([
      _,
      u,
      {
        [`${_}--disabled`]: p,
        [`${_}--text`]: !!a,
        [`${_}--cta-styling`]: n,
        [`${_}--button-styling`]: !n,
        [`${_}--button-styling--md`]: !n,
        [`${_}--button-styling--secondary`]: !n,
        [`${_}--button-styling--icon-only`]: !n && !a
      }
    ])} ${_}`,
    "data-testid": t,
    ...c,
    children: r ? /* @__PURE__ */ s(rt, { "data-testid": `${t}-spinner`, size: "xs", disabled: p }) : /* @__PURE__ */ b(sr, { children: [
      i === "left" && e,
      a,
      i === "right" && e
    ] })
  }
);
function nt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var V = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var F;
function ut() {
  return F || (F = 1, function(t) {
    (function() {
      var u = {}.hasOwnProperty;
      function e() {
        for (var r = "", a = 0; a < arguments.length; a++) {
          var n = arguments[a];
          n && (r = i(r, p.call(this, n)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return e.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var a = "";
        for (var n in r)
          u.call(r, n) && r[n] && (a = i(a, this && this[n] || n));
        return a;
      }
      function i(r, a) {
        return a ? r ? r + " " + a : r + a : r;
      }
      t.exports ? (e.default = e, t.exports = e) : window.classNames = e;
    })();
  }(V)), V.exports;
}
var pt = ut();
const it = /* @__PURE__ */ nt(pt), st = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, ct = it.bind(st), G = "purpur-icon", ot = "md", lt = (t) => t.filter((u) => Object.keys(u).length >= 1).map((u) => `${u.name}="${u.value}"`).join(" "), dt = ({ content: t = "", title: u } = {}) => {
  const e = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    u ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], p = u ? `<title>${u}</title>` : "";
  return `<svg ${lt(e)}>${p}${t}</svg>`;
}, _t = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), rr = ({
  ["data-testid"]: t,
  svg: u,
  allyTitle: e,
  className: p,
  size: i = ot,
  ...r
}) => {
  const a = dt({
    content: _t(u.svg),
    title: e
  }), n = ct(p, G, `${G}--${i}`);
  return /* @__PURE__ */ s(
    "span",
    {
      className: n,
      "data-testid": t,
      dangerouslySetInnerHTML: { __html: a },
      ...r
    }
  );
};
rr.displayName = "Icon";
const gt = {
  name: "checkmark",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M21.06 3.795a.9.9 0 0 1 .145 1.264l-11.5 14.5a.9.9 0 0 1-1.341.077l-6-6a.9.9 0 0 1 1.272-1.272l5.286 5.286L19.795 3.94a.9.9 0 0 1 1.264-.145Z" clip-rule="evenodd"/></svg>',
  keywords: ["checkmark"],
  category: "utility"
}, tr = (t) => /* @__PURE__ */ s(rr, { ...t, svg: gt });
tr.displayName = "IconCheckmark";
function ht(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var D = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var U;
function ft() {
  return U || (U = 1, function(t) {
    (function() {
      var u = {}.hasOwnProperty;
      function e() {
        for (var r = "", a = 0; a < arguments.length; a++) {
          var n = arguments[a];
          n && (r = i(r, p(n)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return e.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var a = "";
        for (var n in r)
          u.call(r, n) && r[n] && (a = i(a, n));
        return a;
      }
      function i(r, a) {
        return a ? r ? r + " " + a : r + a : r;
      }
      t.exports ? (e.default = e, t.exports = e) : window.classNames = e;
    })();
  }(D)), D.exports;
}
var vt = ft();
const mt = /* @__PURE__ */ ht(vt), m = {
  "purpur-paragraph": "_purpur-paragraph_1rh57_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1rh57_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1rh57_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1rh57_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1rh57_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1rh57_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1rh57_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1rh57_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1rh57_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1rh57_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1rh57_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1rh57_60",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1rh57_67",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1rh57_75"
}, yt = {
  PARAGRAPH100: "paragraph-100"
}, y = "purpur-paragraph", M = ({
  ["data-testid"]: t,
  children: u,
  className: e,
  disabled: p,
  enableHyphenation: i = !1,
  negative: r = !1,
  variant: a = yt.PARAGRAPH100,
  ...n
}) => {
  const c = mt([
    e,
    m[y],
    m[`${y}--${a}`],
    {
      [m[`${y}--hyphens`]]: i,
      [m[`${y}--disabled`]]: p,
      [m[`${y}--negative`]]: r
    }
  ]);
  return /* @__PURE__ */ s("p", { ...n, className: c, "data-testid": t, children: u });
};
M.displayName = "Paragraph";
const bt = {
  "purpur-card-feature-list": "_purpur-card-feature-list_198s4_1",
  "purpur-card-feature-list__list-item": "_purpur-card-feature-list__list-item_198s4_7"
}, K = o.bind(bt), W = "purpur-card-feature-list", $t = ({
  ["data-testid"]: t = "purpur-card-feature-list",
  listItems: u
}) => u && u.length > 0 ? /* @__PURE__ */ s("ul", { className: K(W), "data-testid": t, children: u.map((e) => /* @__PURE__ */ b(
  "li",
  {
    className: K(`${W}__list-item`),
    "data-testid": `${t}-item`,
    children: [
      /* @__PURE__ */ s(tr, { size: "xs" }),
      /* @__PURE__ */ s(M, { children: e })
    ]
  },
  e
)) }) : null;
function wt(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Y = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var J;
function xt() {
  return J || (J = 1, function(t) {
    (function() {
      var u = {}.hasOwnProperty;
      function e() {
        for (var r = "", a = 0; a < arguments.length; a++) {
          var n = arguments[a];
          n && (r = i(r, p(n)));
        }
        return r;
      }
      function p(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return e.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var a = "";
        for (var n in r)
          u.call(r, n) && r[n] && (a = i(a, n));
        return a;
      }
      function i(r, a) {
        return a ? r ? r + " " + a : r + a : r;
      }
      t.exports ? (e.default = e, t.exports = e) : window.classNames = e;
    })();
  }(Y)), Y.exports;
}
var Nt = xt();
const jt = /* @__PURE__ */ wt(Nt), w = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, zt = {
  TITLE100: "title-100"
}, x = "purpur-heading", ar = ({
  children: t,
  className: u = "",
  enableHyphenation: e = !1,
  negative: p = !1,
  tag: i,
  variant: r = zt.TITLE100,
  ...a
}) => {
  const n = i, c = jt([
    u,
    w[x],
    w[`${x}--${r}`],
    {
      [w[`${x}--hyphens`]]: e,
      [w[`${x}--negative`]]: p
    }
  ]);
  return /* @__PURE__ */ s(n, { className: c, ...a, children: t });
};
ar.displayName = "Heading";
const Ct = {
  "purpur-card-heading": "_purpur-card-heading_j3j6u_1",
  "purpur-card-heading__header": "_purpur-card-heading__header_j3j6u_6",
  "purpur-card-heading__heading": "_purpur-card-heading__heading_j3j6u_11",
  "purpur-card-heading__icon": "_purpur-card-heading__icon_j3j6u_14"
}, St = {
  "purpur-card-trigger-item--link": "_purpur-card-trigger-item--link_t6ena_1",
  "purpur-card-trigger-item--button": "_purpur-card-trigger-item--button_t6ena_5",
  "purpur-card-trigger-item--disabled": "_purpur-card-trigger-item--disabled_t6ena_18",
  "purpur-card-trigger-item": "_purpur-card-trigger-item_t6ena_1"
}, Q = o.bind(St), g = "purpur-card-trigger-item", At = ({
  ["data-testid"]: t = "purpur-card-trigger-item",
  ["aria-label"]: u,
  disabled: e = !1,
  href: p,
  onClick: i,
  children: r,
  linkElement: a = "a"
}) => {
  const n = ($) => {
    e ? $.preventDefault() : i && i();
  }, c = `${g} ${e ? `${g}--disabled` : ""}`;
  return p ? /* @__PURE__ */ s(
    a,
    {
      "aria-disabled": e,
      "aria-label": u,
      className: `${Q([
        g,
        `${g}--link`,
        {
          [`${g}--disabled`]: e
        }
      ])} ${c}`,
      "data-testid": t,
      href: e ? void 0 : p,
      tabIndex: e ? 0 : void 0,
      onClick: n,
      children: r
    }
  ) : /* @__PURE__ */ s(
    "button",
    {
      "aria-disabled": e,
      "aria-label": u,
      className: `${Q([
        g,
        `${g}--button`,
        {
          [`${g}--disabled`]: e
        }
      ])} ${c}`,
      "data-testid": t,
      type: "button",
      onClick: n,
      children: r
    }
  );
}, N = o.bind(Ct), h = "purpur-card-heading", Ot = ({
  ["data-testid"]: t = "purpur-card-heading",
  ["aria-label"]: u,
  title: e,
  icon: p,
  children: i,
  titleTag: r = "h2",
  enableHyphenation: a,
  onClick: n = void 0,
  href: c = void 0,
  disabled: $ = !1,
  linkElement: nr = "a",
  variant: ur = "title-100",
  ...pr
}) => {
  const ir = N(h, {
    [`${h}--is-interactive`]: n || c,
    [`${h}--disabled`]: $
  });
  return /* @__PURE__ */ b("div", { className: ir, "data-testid": t, children: [
    /* @__PURE__ */ b("div", { className: N(`${h}__header`), children: [
      p && /* @__PURE__ */ s("div", { className: N(`${h}__icon`), children: p }),
      /* @__PURE__ */ s(
        ar,
        {
          tag: r,
          className: N(`${h}__heading`),
          variant: ur,
          enableHyphenation: a,
          ...pr,
          children: n || c ? /* @__PURE__ */ s(
            At,
            {
              "aria-label": u,
              disabled: $,
              href: c,
              onClick: n,
              linkElement: nr,
              children: e
            }
          ) : e
        }
      )
    ] }),
    i
  ] });
}, Zt = {
  "purpur-card-media": "_purpur-card-media_udc1o_1"
}, Mt = o.bind(Zt), kt = "purpur-card-media", qt = ({
  ["data-testid"]: t = "purpur-card-media",
  className: u,
  children: e,
  ...p
}) => /* @__PURE__ */ s("div", { ...p, className: Mt([kt, u]), "data-testid": t, children: e }), Rt = {
  "purpur-card-media-layout": "_purpur-card-media-layout_1yfvb_1"
}, Ht = o.bind(Rt), Pt = "purpur-card-media-layout", Et = ({
  ["data-testid"]: t = "purpur-card-media-layout",
  className: u,
  children: e,
  ...p
}) => /* @__PURE__ */ s("div", { ...p, className: Ht([Pt, u]), "data-testid": t, children: e }), Lt = {
  "purpur-card-overline": "_purpur-card-overline_qhfj0_1"
}, Tt = o.bind(Lt), Bt = "purpur-card-overline", It = ({
  ["data-testid"]: t = "purpur-card-overline",
  overline: u
}) => u ? /* @__PURE__ */ s(M, { variant: "overline-100", className: Tt(Bt), "data-testid": t, children: u }) : null, Vt = {
  "purpur-card-root": "_purpur-card-root_eupww_1",
  "purpur-card-root--primary": "_purpur-card-root--primary_eupww_7",
  "purpur-card-root--secondary": "_purpur-card-root--secondary_eupww_10",
  "purpur-card-root--full-height": "_purpur-card-root--full-height_eupww_13"
}, Ft = o.bind(Vt), A = "purpur-card-root", er = cr(
  ({
    ["data-testid"]: t = "purpur-card-root",
    children: u,
    className: e,
    fullHeight: p = !0,
    variant: i,
    ...r
  }, a) => {
    const n = Ft([
      A,
      e,
      {
        [`${A}--${i}`]: i,
        [`${A}--full-height`]: p
      }
    ]);
    return /* @__PURE__ */ s("div", { className: n, "data-testid": t, ref: a, ...r, children: u });
  }
);
er.displayName = "CardRoot";
const O = o.bind(_r), Z = "purpur-card", l = ({ children: t, className: u, ...e }) => {
  const p = O([Z, u]);
  return /* @__PURE__ */ s(
    "div",
    {
      className: O(`${Z}__container`, {
        [`${Z}__container--full-height`]: e.fullHeight
      }),
      children: /* @__PURE__ */ s(er, { className: O(p), ...e, children: t })
    }
  );
};
l.Badge = Tr;
l.Content = Fr;
l.ContentContainer = Ur;
l.Cta = et;
l.FeatureList = $t;
l.Overline = It;
l.Heading = Ot;
l.Media = qt;
l.MediaLayout = Et;
l.displayName = "Card";
export {
  l as Card
};
//# sourceMappingURL=card.es.js.map
